module.exports = __webpack_public_path__ + "img/bsignup-continue-1@2x.876d2650.png";